import { useEffect, useState } from "react";
import { getLandingPageSettings } from "../../api/getLandingPageSettings";
import { trackClick } from "../../utils/loadLandingTracking";
import "./ConnectExpert.css";

const ConnectExpert = () => {
  const [content, setContent] = useState({
    badge: "",
    title1: "",
    title2: "",
    description:
      "",
    btnExpertUrl: "",
    btnTrialUrl: "",
  });

  useEffect(() => {
    const fetchSettings = async () => {
      const data = await getLandingPageSettings();
      if (!data) return;

      setContent({
        badge:
          data?.newsletter_badge_text?.value ||
          data?.newsletter_badge_text ||
          content.badge,

        title1:
          data?.newsletter_title_line_1?.value ||
          data?.newsletter_title_line_1 ||
          content.title1,

        title2:
          data?.newsletter_title_line_2?.value ||
          data?.newsletter_title_line_2 ||
          content.title2,

        description:
          data?.newsletter_description?.value ||
          data?.newsletter_description ||
          content.description,

        btnExpertUrl:
          data?.newsletter_button_2_url?.value ||
          data?.newsletter_button_2_url ||
          content.btnExpertUrl,

        btnTrialUrl:
          data?.newsletter_button_1_url?.value ||
          data?.newsletter_button_1_url ||
          content.btnTrialUrl,
      });
    };

    fetchSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="connect-expert py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <span className="connect-badge mb-3 d-inline-block">
              {content.badge}
            </span>

            <h2 className="connect-title mb-3">
              {content.title1}
              <br />
              {content.title2}
            </h2>

            <p className="connect-desc mb-4">{content.description}</p>

            <div className="connect-actions">
              <a
                href={content.btnExpertUrl}
                target="_blank"
                rel="noreferrer"
                className="btn btn-outline-primary btn-lg me-2"
                onClick={() => trackClick("connect-expert-btn", { category: "cta" })}
              >
                Connect to a Product Expert
              </a>

              <a
                href={content.btnTrialUrl}
                target="_blank"
                rel="noreferrer"
                className="btn btn-primary btn-lg"
                onClick={() => trackClick("connect-trial-btn", { category: "cta" })}
              >
                Start Free Trial
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConnectExpert;
